import React from 'react';
import { useParams } from 'react-router-dom';

import RolesTable from '../components/tables/RolesTable';

const CompanyRolesUsedPage: React.FC = () => {
  const { companyId } = useParams();
  return <RolesTable companyId={Number(companyId)} />;
};

export default CompanyRolesUsedPage;
